import { render, staticRenderFns } from "./SectionsList.vue?vue&type=template&id=043ce114&scoped=true&"
import script from "./SectionsList.vue?vue&type=script&lang=js&"
export * from "./SectionsList.vue?vue&type=script&lang=js&"
import style0 from "./SectionsList.vue?vue&type=style&index=0&id=043ce114&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043ce114",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LessonList: require('/opt/buildhome/repo/components/lists/LessonList.vue').default})
